import { userApi } from "./cdsApiClient";
import { ICurrentUserResponse } from "../clients/cds_client/api";
import {
  getCurrentUserPromiseCache,
  setCurrentUserPromiseCache,
  readCurrentUserDataFromSession,
  writeCurrentUserDataToSession,
  clearCurrentUserCache,
} from "../utils/currentUserCache";


export async function getUser(): Promise<ICurrentUserResponse> {
  // 1) If there's an in-flight (or already-resolved) promise, reuse it.
  const existing = getCurrentUserPromiseCache();
  if (existing) return existing as Promise<ICurrentUserResponse>;

  // 2) If sessionStorage has user data (tab-scoped), use it to avoid refetch on reload/navigation.
  const cachedData = readCurrentUserDataFromSession();
  if (cachedData) {
    return Promise.resolve({
      success: true,
      data: cachedData,
    } as unknown as ICurrentUserResponse);
  }

  // 3) Atomically create+assign promise before awaiting anything (prevents race duplicates).
  const promise = userApi
    .getCurrentUser()
    .then((response: any) => {
      const payload: ICurrentUserResponse = response.data;
      if (payload?.data) {
        writeCurrentUserDataToSession(payload.data);
      }
      return payload;
    })
    .catch((error: any) => {
      // Ensure failures don't stick: allow next call to retry.
      clearCurrentUserCache();
      throw error;
    });

  setCurrentUserPromiseCache(promise);
  return promise;
}

